import { render, staticRenderFns } from "./InitialBriefingPage.vue?vue&type=template&id=6975fece&"
import script from "./InitialBriefingPage.vue?vue&type=script&lang=js&"
export * from "./InitialBriefingPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports